import { Clickable, Col, Icon, Input, Row, Text } from 'components';
import { nations, sports, theme } from 'lib';
import styled from 'styled-components';
import FilterSelect from './FilterSelect';

const options = [
  { value: 'All' },
  { value: 'Teams', opt: 'team' },
  { value: 'Athletes', opt: 'athlete' },
  { value: 'Fans', opt: 'fan' },
  { value: 'Admins' },
  { value: 'Pending approval' }
];

const ANY = { value: 'Any' };

const emailOptions = [ANY, { value: 'Verified', opt: true }, { value: 'Unverified', opt: false }];

// The exact list the Team form offers, so a filter value is always one an admin could have saved.
const countryOptions = [ANY, ...nations.map(({ value }) => ({ value }))];

// Keys such as `americanFootball` read as words. Built from the app's own sports list so a filter
// value is always one a user can actually have; the list repeats a few names, hence the Set.
const sportOptions = [
  ANY,
  ...[...new Set(sports.map(({ name }) => name))].map((name) => ({
    value: name.replace(/([A-Z0-9])/g, ' $1').replace(/^./, (c) => c.toUpperCase()),
    opt: name
  }))
];

const idOptions = [
  ANY,
  { value: 'Pending action', opt: 'pendingAction' },
  { value: 'Pending verification', opt: 'pendingVerification' },
  { value: 'Not verified', opt: 'notVerified' },
  { value: 'Verified', opt: 'verified' },
  { value: 'Verified and dismissed', opt: 'verifiedAndDismissed' }
];

// Only account-level filters live here. Who follows or subscribes to a team is read from the
// Teams tab.
export const EMPTY_FILTERS = { email: ANY, id: ANY, country: ANY, sport: ANY };

const Page = styled.div`
  width: 100%;
  padding: 12px 24px 16px;
  box-sizing: border-box;
`;

const Primary = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 12px;
`;

const isActive = (filters) =>
  Object.entries(EMPTY_FILTERS).some(([key, empty]) => {
    const value = filters[key];

    return typeof empty === 'object' && empty?.value ? value.value !== empty.value : !!value;
  });

const Filters = ({ type, setType, text, setText, filters, setFilters }) => {
  const set = (key) => (value) => setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <Page>
      <Primary>
        <Col noFlex>
          <Text marg="0 0 4px 4px" b2 med>
            Filter by owner
          </Text>

          <Input
            big
            search
            wid="300px"
            placeholder="Name, username or email..."
            value={text}
            onChange={({ target }) => setText(target.value)}
          />
        </Col>

        <FilterSelect
          label="Category"
          wid="170px"
          selected={type}
          options={options}
          onSelect={setType}
        />

        <FilterSelect
          label="Email"
          wid="140px"
          selected={filters.email}
          options={emailOptions}
          onSelect={set('email')}
        />

        <FilterSelect
          label="ID status"
          wid="190px"
          selected={filters.id}
          options={idOptions}
          onSelect={set('id')}
        />

        <FilterSelect
          label="Sport"
          wid="170px"
          selected={filters.sport}
          options={sportOptions}
          onSelect={set('sport')}
          searchable
        />

        <FilterSelect
          label="Country"
          wid="200px"
          selected={filters.country}
          options={countryOptions}
          onSelect={set('country')}
          searchable
        />

        {isActive(filters) && (
          <Clickable onClick={() => setFilters(EMPTY_FILTERS)}>
            <Row noFlex center gap="6px" pad="0 0 12px">
              <Icon type="close" dimensions={12} />
              <Text b2 med col={theme.GREY_60}>
                Clear filters
              </Text>
            </Row>
          </Clickable>
        )}
      </Primary>
    </Page>
  );
};

export default Filters;
